module.exports = __webpack_public_path__ + "static/media/we_provide_img.adc4af27.png";